import React from 'react';
import { Paper, Title, Text, Group, Button, Stack, Badge } from '@mantine/core';
import { IconEdit, IconClock } from '@tabler/icons-react';
import BusinessHoursForm from '../forms/BusinessHoursForm';
import { useSalon } from '../../context/SalonContext';
import { useMediaQuery } from '@mantine/hooks';
function BusinessHoursSettings({ editingSection, setEditingSection, handleUpdate }) {
  const { businessInfo, currentUser } = useSalon();
  const isMobile = useMediaQuery('(max-width: 768px)');
  return (
    <Paper p={{ base: 'sm', sm: 0 }} radius="md" withBorder={isMobile}>
      <Group position="apart" mb="md">
        <Group>
          <IconClock size={isMobile ? 16 : 24} />
          <Title order={3} size={isMobile ? 'lg' : 'xl'}>Business Hours</Title>
        </Group>
        {(currentUser?.role === "Owner" || currentUser?.role === "Manager") && (
          <Button 
            variant="light" 
            color={editingSection === 'hours' ? "red" : "violet"}
            onClick={() => editingSection === 'hours' ? setEditingSection(null) : setEditingSection('hours')}
            ml="auto"
            leftSection={<IconEdit size={16} />}
          >
            {editingSection === 'hours' ? 'Cancel Edit' : 'Edit'}
          </Button>
        )}
      </Group>

      {editingSection === 'hours' ? (
        <BusinessHoursForm 
          initialData={businessInfo}
          onSubmit={handleUpdate}
          buttonText="Save Hours"
        />
      ) : (
        <Stack gap="0">
          {['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].map((day) => (
            <Group key={day} py="xs" gap="md">
              <Text fw={600} style={{textTransform: 'capitalize'}}>{day}</Text>
              {businessInfo?.[`${day}_open_time`] ? (
                <Group>
                  <Text>
                    {businessInfo[`${day}_open_time`]} - {businessInfo[`${day}_end_time`]}
                  </Text>
                  <Badge color="green" variant="light">Open</Badge>
                </Group>
              ) : (
                <Badge color="red" variant="light">Closed</Badge>
              )}
            </Group>
          ))}
        </Stack>
      )}
    </Paper>
  );
}

export default BusinessHoursSettings; 